import SendConfirmationModal from './SendConfirmationModal.component';

export default SendConfirmationModal;
